<span [ngClass]="['qw-app-image', appAlias]"></span>